import { useMap } from '@vis.gl/react-google-maps';
import { FC, useEffect, useMemo, useRef } from 'react';

import { HeatmapLayer } from '@deck.gl/aggregation-layers/typed';
import { GoogleMapsOverlay } from '@deck.gl/google-maps/typed';

import { WeightedHeatmapLocation } from '../../api/dtos/dtos';

interface IHeatmapLayerProps {
    show: boolean;
    data: WeightedHeatmapLocation[] | undefined;
}

const HeatMapLayer: FC<IHeatmapLayerProps> = ({
    show,
    data
}) => {
    const map = useMap();

    //
    // Create overlay ref
    //
    const overlayRef = useRef(
        new GoogleMapsOverlay({})
    );

    //
    // Layers
    //
    const layers = useMemo(() => {
        if (!show || !data?.length) {
            return [];
        }

        return [
            new HeatmapLayer<WeightedHeatmapLocation>({
                id: 'heatmap-layer',

                data,

                getPosition: d => [
                    d.longitude,
                    d.latitude
                ],

                getWeight: d => d.weight ?? 1,

                radiusPixels: 30,
                intensity: 500,
                threshold: 0.15,
                opacity: 0.4,

                colorRange: [
                    [102, 255, 0],
                    [102, 255, 0],
                    [147, 255, 0],
                    [193, 255, 0],
                    [238, 255, 0],
                    [244, 227, 0],
                    [249, 198, 0],
                    [255, 170, 0],
                    [255, 113, 0],
                    [255, 57, 0],
                    [255, 0, 0]
                ]
            })
        ];
    }, [show, data]);

    //
    // Attach overlay to map
    //
    useEffect(() => {
        if (!map) {
            return;
        }

        overlayRef.current.setMap(map);
    }, [map]);

    //
    // Update layers only
    //
    useEffect(() => {
        overlayRef.current.setProps({
            layers
        });
    }, [layers]);

    return null;
};

export default HeatMapLayer;